import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter } from 'react-router-dom'; 

// ------------------------------------------------------- //

import App from './App';

// ======================================================= //

import {createTheme, ThemeProvider} from '@mui/material/styles';
import { UserProvider } from './context/user.context';

const theme = createTheme({
	palette: {
		primary: {
		  	main: '#79B9E8',
		},
		secondary: {
		  	main: '#767676',
		},
	},
});

// ------------------------------------------------------- //

ReactDOM.render(
    <BrowserRouter basename={'timetables'}>
		<UserProvider>
			<ThemeProvider theme={theme}>
				<App />
			</ThemeProvider>
		</UserProvider>
    </BrowserRouter>, 

    document.getElementById('root')
);

document.getElementById('root').style.fontFamily = '"Roboto","Helvetica","Arial",sans-serif';

// ======================================================= //